import * as React from 'react';
import { useSelector } from 'react-redux';
import { getNewbuildingReviewsStat } from '../../selectors/newbuilding';
import { getPrettyFloat, Star, EStarSize, EStarTheme } from '@cian/frontend-reviews-components';
import { UIHeading2 } from '@cian/ui-kit';

import * as style from './HeaderRatingStat.css';

export const HeaderRatingStat: React.FC = () => {
  const reviewStat = useSelector(getNewbuildingReviewsStat);

  if (!reviewStat?.reviewsCount) {
    return <Star size={EStarSize.M} theme={EStarTheme.NotFilled} />;
  }

  return (
    <span className={style['rating']}>
      <UIHeading2 as="span" color="decorative-orange">
        {getPrettyFloat(reviewStat.rating)}
      </UIHeading2>
      <Star size={EStarSize.M} theme={EStarTheme.Filled} />
    </span>
  );
};
